import apiClient from "./apiClient";

/**
 * Fetch list of invoices with optional filters from Middleware
 */
export const getInvoices = async (companyCode, options = {}) => {
  try {
    const params = { companyCode };
    if (options.clientId) params.clientId = options.clientId;
    if (options.companyName) params.companyName = options.companyName;
    if (options.leadId) params.leadId = options.leadId;
    if (options.employeeId) params.employeeId = options.employeeId;
    if (options.search) params.search = options.search;
    if (options.dateFrom) params.dateFrom = options.dateFrom;
    if (options.dateTo) params.dateTo = options.dateTo;
    if (options.page) params.page = options.page;
    if (options.pageSize) params.pageSize = options.pageSize;

    const config = {
      params,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
      timeout: 10000,
    };
    if (options.signal) {
      config.signal = options.signal;
    }

    const data = await apiClient.get("/api/invoices", config);

    const invoices = data?.invoices || data?.items || data?.data || (Array.isArray(data) ? data : []);

    return {
      success: true,
      invoices,
      total: data?.total || invoices.length,
      stats: data?.stats || {
        totalAmount: 0,
        totalPaid: 0,
        totalPending: 0,
      },
    };
  } catch (error) {
    if (error?.name === "CanceledError" || error?.code === "ERR_CANCELED" || error?.message === "canceled") {
      throw error;
    }
    console.error("[InvoiceService] getInvoices error:", error);
    return {
      success: false,
      invoices: [],
      total: 0,
      stats: { totalAmount: 0, totalPaid: 0, totalPending: 0 },
    };
  }
};

/**
 * Create a new invoice
 */
export const createInvoice = async (companyCode, payload) => {
  try {
    const data = await apiClient.post(
      "/api/invoices",
      { ...payload, companyCode },
      { headers: companyCode ? { "x-active-company-code": companyCode } : {} }
    );
    return data;
  } catch (error) {
    console.error("[InvoiceService] createInvoice error:", error);
    return { success: false, message: error.message };
  }
};

/**
 * Update an existing invoice
 */
export const updateInvoice = async (companyCode, id, payload) => {
  try {
    const data = await apiClient.put(
      `/api/invoices/${id}`,
      { ...payload, companyCode },
      { headers: companyCode ? { "x-active-company-code": companyCode } : {} }
    );
    return data;
  } catch (error) {
    console.error("[InvoiceService] updateInvoice error:", error);
    return { success: false, message: error.message };
  }
};

/**
 * Fetch Clients List for Invoice creation
 */
export const getClientsList = async (companyCode) => {
  try {
    const data = await apiClient.get("/api/clients", {
      params: { companyCode },
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return data?.data || data?.clients || (Array.isArray(data) ? data : []);
  } catch (error) {
    console.error("[InvoiceService] getClientsList error:", error);
    return [];
  }
};

/**
 * Save Customer GST Number for a Company / Lead / Client
 */
export const saveCompanyGst = async (companyCode, payload) => {
  try {
    const data = await apiClient.post(
      "/api/invoices/company-gst",
      { ...payload, companyCode },
      { headers: companyCode ? { "x-active-company-code": companyCode } : {} }
    );
    return data;
  } catch (error) {
    console.error("[InvoiceService] saveCompanyGst error:", error);
    return { success: false, message: error.message };
  }
};
